export default {
  routerBase: {
    'install': 'Setting',
    'homepage': 'Home',
    'statistics': 'Statistics',
    'history': 'History',
    'starttest': 'Measurement',
    'family': 'Family',
    'myfamily': 'My Family',
    'setting': 'Setting',
    'data': 'Data',
    'mall': 'Mall',
    'personal': 'Personal',
    'addfamily': 'Add Family',
    'bindaccount': 'Bind Account',
    'relationShip': 'Relation Ship',
    'directionforuse': 'Instructions',
    'consultation': 'Consultation',
    'measurement': 'Results',
    'improveprofile': 'Fill in profile',
    'changephone': 'Change Telephone Number ',
    'information': 'INFO',
    'health report': 'Health Report',
    'healthwarning': 'Health Warning',
    'healthadvice': 'Health Suggestion',
    'pressure': 'Blood Pressure',
    'sugar': 'Blood Glucose',
    'heartrate': 'Heart Rate',
    'oxygen': 'Blood Oxygen',
    'step': 'Steps',
    'hrv': 'HRV ',
    'apnea': 'Apnea Times',
    'description': 'Description',
    'submitorder': 'Submit Order',
    'orderlist': 'Order List',
    'personaldetails': 'Personal Information',
    'mdi': 'Manual Input',
    'record': 'Login',
    'help': 'Help',
    'downloadAPP': 'Download Guider Health APP ',
    'associatedmobile': ' Associated telephone number ',
    'regiese': 'regiese',
    'startmenu': 'measuring',
    'mys': ' My ',
    'privacypolicy': 'Privacy Policy',
    'register': 'Register',
    'putcode': 'Send Code'

  }
}
